import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Requirement from "../../pages/requirement/Requirement";
import { CourseOption } from "../../types/course.response";

interface RequirementOverlayProps {
    programId: string;
    requirementId: string;
    onClose: () => void;
    onDataChanged: () => void;
    userCourses?: CourseOption[];
}

export default function RequirementOverlay({ programId, requirementId, onClose, onDataChanged, userCourses }: RequirementOverlayProps) {
    // 数据来自共享的切片编排器:宿主页已加载的 skeleton/切片直接复用,
    // 缓存命中时打开零网络请求(课程补水缓存也共享)。
    const scrollRef = useRef<HTMLDivElement>(null);
    const location = useLocation();
    const previousPathRef = useRef(location.pathname + location.search);

    useEffect(() => {
        window.history.replaceState(null, '', `/programs/${programId}/requirements/${requirementId}`);
        return () => {
            window.history.replaceState(null, '', previousPathRef.current);
        };
    }, []);

    // Escape key to close
    useEffect(() => {
        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("keydown", onKeyDown);
        return () => document.removeEventListener("keydown", onKeyDown);
    }, [onClose]);

    // Prevent scroll from leaking to layers underneath
    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;
        const onWheel = (e: WheelEvent) => {
            const { scrollTop, scrollHeight, clientHeight } = el;
            const atTop = scrollTop <= 0 && e.deltaY < 0;
            const atBottom = scrollTop + clientHeight >= scrollHeight && e.deltaY > 0;
            if (atTop || atBottom) {
                e.preventDefault();
            }
        };
        el.addEventListener("wheel", onWheel, { passive: false });
        return () => el.removeEventListener("wheel", onWheel);
    }, []);

    return (
        <div ref={scrollRef} className="fixed top-16 left-0 xl:left-[245px] right-0 bottom-0 bg-white z-50 overflow-y-auto overscroll-none">
            <Requirement
                overlayProgramId={programId}
                overlayRequirementId={requirementId}
                onClose={onClose}
                onDataChanged={onDataChanged}
                scrollContainerRef={scrollRef}
                initialUserCourses={userCourses}
            />
        </div>
    );
}
